/** Appointment status constants */
export enum APPOINTMENT_STATUS {
	CONFIRMED = 'Confirmed',
	PENDING = 'Request Pending',
	PRE_BOOKING = 'Pre-Booking',
	CONFIRM_PENDING = 'Confirm Pending',
	PENDING_APPOINTMENT_CONFIRMATION = 'Pending Appointment Confirmation',
}

/** Procedure Message Modal Answers constants */
export enum PROCEDURE_MESSAGE_MODAL_ANSWERS {
	YES = 'YES',
	NO = 'NO',
}

/** Procedure constants */
export enum PROCEDURE_CONSTANTS {
	PHYSICAL_EXAM = 'Physical Exam',
	PHYSICAL_EXAM_ID = 1,
	INOCULATION = 'Inoculation',
	CUTOFF_DATE_FOR_NEW_HA = '08/20/2021', // cutoff is 8/19/2021 so any date on or before is validated
	RESCHEDULE = 'reschedule',
	HEALTH_COACHING = 'Health Coaching',
	HEALTH_COACHING_ID = -2,
}

export enum AUTH_COMPONENTS {
	LOGIN_COMPONENT = 'login-component',
	SIGNUP_COMPONENT = 'signup',
	RESET_COMPONENT = 'reset',
}

/** Physical exam status constants */
export enum PE_STATUS {
	NOT_SCHEDULED = 1,
	SCHEDULED = 2,
	COMPLETED = 3,
}

export enum DAYS_LEFT {
	PHYSICAL_EXAM = 90,
}

export enum INCENTIVE_CONSTANTS {
	MANUAL_CODE_KEY = 'code',
	PAYLOAD_KEY = 'incentiveCode',
	DYNAMIC_DELAY_MS = 800,
	PROMO_QUERY_KEY = 'pc',
	REFERRAL_QUERY_KEY = 'rc',
	NONE_TYPE = 'NONE',
	PROMO_TYPE = 'PROMO_CODE',
	REFERRAL_TYPE = 'REFERRAL_CODE',
	RETURN_URL_ADDITIONAL_DATA_KEY = 'promoReferralData',
	PROMO_DEFAULT_MESSAGE = 'Promo Code is valid',
	REFERRAL_DEFAULT_MESSAGE = 'Referral Code is valid',
	PROMO_DEFAULT_ERROR = 'Promo Code is not valid',
	REFERRAL_DEFAULT_ERROR = 'Referral Code is not valid',
	REFERRAL_SELF_CODE_ERROR = 'SELF_CODE',
}
